import React from "react";
import PropTypes from "prop-types";

import { UIRadioGroup } from "../../../../ui";
import { PAYMENT_METHODS } from "./publishPayConstants";

/** Offline bank transfer is the only method for now; online is shown as coming soon. */
const PaymentMethodField = ({ t, stacked }) => {
  const options = [
    { value: PAYMENT_METHODS.offline, label: t.offline },
    {
      value: PAYMENT_METHODS.online,
      label: (
        <>
          {t.online}{" "}
          <span className="text-body-xs publish-pay-step__soon">
            ({t.comingSoon})
          </span>
        </>
      ),
      disabled: true,
    },
  ];

  return (
    <UIRadioGroup
      row={!stacked}
      name="payment_method"
      value={PAYMENT_METHODS.offline}
      options={stacked ? options.reverse() : options}
    />
  );
};

PaymentMethodField.propTypes = {
  /** `events.creatEvent.publishPay` copy. */
  t: PropTypes.object.isRequired,
  /** One option per line with Online first (upgrade payment popup). */
  stacked: PropTypes.bool,
};

PaymentMethodField.defaultProps = {
  stacked: false,
};

export default PaymentMethodField;
